<template>
  <b-navbar variant="white" class="shadow p-3 mb-5 bg-white">
    <div class="bg-white" style="margin: 0 auto;">
      <b-navbar-brand href="#">
        <img width="100%" src="@/assets/logo_evento.jpg" class="img img-responsive" alt="Logo">
      </b-navbar-brand>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: 'Topo'
}
</script>

<style>

</style>
